import React from 'react';

export const ProjectsAnalyticsDashboardContext = React.createContext({});

export const useProjectsAnalyticsDashboardContext = () =>
  React.useContext(ProjectsAnalyticsDashboardContext);
